import React from "react";
import PaySupplier from "pages/PaySupplier/PaySupplier";

const PayConsultant = () => {
  return <PaySupplier is_type="Consultant" />;
};
export default PayConsultant;
